import React from "react";

export const MARKETPLACES = {
  ATVPDKIKX0DER: "US", A2EUQ1WTGCTBG2: "CA", A1AM78C64UM0Y8: "MX", A2Q3Y263D00KWC: "BR", A1F83G8C2ARO7P: "UK",
  A1PA6795UKMFR9: "DE", A13V1IB3VIYZZH: "FR", APJ6JRA9NG5V4: "IT", A1RKKUPIHCS9HS: "ES", A1805IZSGTT6HS: "NL",
  A2NODRKZP88ZB9: "SE", A1C3SOZRARQ6R3: "PL", AMEN7PMS3EDWL: "BE", A33AVAJ2PDY3EV: "TR", A21TJRUUN4KGV: "IN",
  A1VC38T7YXB528: "JP", A39IBJ37TRP1C6: "AU", A19VAU5U5O7RUS: "SG", A2VIGQ35RCS4UG: "AE", A17E79C6D8DWNP: "SA",
  ARBP9OOSHTCHU: "EG",
};

const BAD_STATUS = ["SUSPENDED", "ARCHIVED", "ARCHIVING", "FAILED", "FAILED_FIRST_CONFIRMATION",
  "FAILED_CONFIRMATION", "CONFIRMATION_FAILED", "DELETED", "INACTIVE"];

const whole = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
const money = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmt = (v) => (v == null ? "–" : whole.format(v));
export const fmt2 = (v) => (v == null ? "–" : money.format(v));
export const pct = (a, b) => (b ? `${Math.round((100 * a) / b)}%` : "–");
export const hrs = (h) => (h == null ? "–" : h < 1 ? `${Math.round(h * 60)} min` : `${h.toFixed(1)} h`);
export const levelOf = (severity) => (severity === 2 ? "red" : severity === 1 ? "amber" : "ok");
export const todayUtc = () => new Date().toISOString().slice(0, 10);

export function ago(iso) {
  if (!iso) return "never";
  const h = (Date.now() - Date.parse(iso)) / 36e5;
  if (h < 1) return `${Math.max(0, Math.round(h * 60))} min ago`;
  return h < 48 ? `${h.toFixed(1)} h ago` : `${Math.round(h / 24)} d ago`;
}

export function utcLabel(iso, withYear = true) {
  if (!iso) return "";
  const opts = { timeZone: "UTC", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" };
  if (withYear) opts.year = "numeric";
  return `${new Date(iso).toLocaleString("en-US", opts)} UTC`;
}

export const Dash = () => <span className="ams-dash">–</span>;

export const Num = ({ value }) => (value == null ? <Dash /> : fmt(value));

export function Marketplace({ id }) {
  if (!id) return <Dash />;
  return (
    <>
      {id} {MARKETPLACES[id] && <span className="ams-cc">{MARKETPLACES[id]}</span>}
    </>
  );
}

const TAG_TEXT = { red: "Dev work", amber: "Recovering", ok: "Healthy" };
export const Tag = ({ level, children }) => (
  <span className={`ams-tag ams-tag--${level}`}>{children || TAG_TEXT[level]}</span>
);

export const Chip = ({ level, children }) => <span className={`ams-state ams-state--${level}`}>{children}</span>;

export function StatusChip({ status }) {
  const s = (status || "UNKNOWN").toUpperCase();
  const level = s === "ACTIVE" ? "ok" : BAD_STATUS.includes(s) ? "red" : "amber";
  return <Chip level={level}>{s.toLowerCase().replace(/_/g, " ")}</Chip>;
}

export function RebuildChip({ status }) {
  const level = status === "ok" ? "ok" : ["error", "never", "not linked"].includes(status) ? "red" : "amber";
  return <Chip level={level}>{status}</Chip>;
}

export function Reasons({ issues }) {
  if (!issues || !issues.length) return <div className="ams-fine">Nothing to do</div>;
  return issues.map((i, k) => (
    <div key={k} className={`ams-why--${i.level}`}>{i.text}</div>
  ));
}

export function FilterChips({ options, value, onChange, counts }) {
  return (
    <div className="ams-chips" role="group" aria-label="Filter">
      {options.map(([key, label]) => (
        <button key={key} type="button" className={`ams-chip ams-chip--${key}`} aria-pressed={value === key}
                onClick={() => onChange(key)}>
          {label}
          {counts && counts[key] != null && <span className="ams-chip-count">{counts[key]}</span>}
        </button>
      ))}
    </div>
  );
}

/** {all, red, amber, ok} counts for the chips. */
export function countLevels(items, getLevel) {
  const c = { all: items.length, red: 0, amber: 0, ok: 0 };
  items.forEach((x) => { c[getLevel(x)] += 1; });
  return c;
}

export const Empty = ({ cols, children }) => (
  <tr>
    <td colSpan={cols} className="ams-empty">{children}</td>
  </tr>
);
